/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debt_DescriptionInputs */

const en_case_field_debt_description = /** @type {(inputs: Case_Field_Debt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

const pt_br2_case_field_debt_description = /** @type {(inputs: Case_Field_Debt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentários`)
};

/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Case_Field_Debt_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debt_description = /** @type {((inputs?: Case_Field_Debt_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debt_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debt_description(inputs)
	return pt_br2_case_field_debt_description(inputs)
});